(() => {
  const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const abbreviations = new Map([
    ['uk', 'united kingdom'], ['u k', 'united kingdom'],
    ['us', 'united states'], ['u s', 'united states'],
    ['usa', 'united states'], ['u s a', 'united states'],
    ['uae', 'united arab emirates'], ['u a e', 'united arab emirates'],
  ]);

  const initialize = (finder) => {
    if (finder.dataset.enhanced === 'true') return;
    const input = finder.querySelector('[data-rr-country-input]');
    const controls = finder.querySelector('[data-rr-finder-controls]');
    const count = finder.querySelector('[data-rr-country-count]');
    const empty = finder.querySelector('[data-rr-country-empty]');
    const clear = finder.querySelector('[data-rr-country-clear]');
    const entries = Array.from(finder.querySelectorAll('[data-rr-country]')).map((element) => ({
      element,
      search: normalize(`${element.dataset.search} ${element.textContent}`),
    }));
    if (!input || !controls || !count || !empty || !clear || entries.length === 0) return;

    const full = finder.dataset.full === 'true';
    let searchTimer;
    let announcedValue = '';

    const dispatch = (name, detail) => {
      finder.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { finderId: finder.id, ...detail } }));
    };

    const update = () => {
      const query = normalize(input.value);
      const terms = (abbreviations.get(query) || query).split(' ').filter(Boolean);
      let matches = 0;
      entries.forEach(({ element, search }) => {
        const matched = terms.every((term) => search.includes(term));
        element.hidden = !matched;
        if (matched) matches += 1;
      });

      const template = query
        ? matches === 0 ? finder.dataset.noResults : matches === 1 ? finder.dataset.oneResult : finder.dataset.countTemplate
        : finder.dataset.allTemplate;
      count.textContent = template.replace('__count__', matches);
      empty.hidden = matches !== 0;
      clear.hidden = input.value.length === 0;
      window.clearTimeout(searchTimer);
      if (query && query !== announcedValue) {
        searchTimer = window.setTimeout(() => {
          dispatch('rr:country-search', { resultCount: matches, mode: full ? 'directory' : 'homepage' });
          announcedValue = query;
        }, 450);
      }
      if (!query) announcedValue = '';
    };

    input.addEventListener('input', update);
    input.addEventListener('search', update);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && input.value) {
        event.preventDefault();
        input.value = '';
        update();
      }
    });
    clear.addEventListener('click', () => {
      input.value = '';
      update();
      input.focus();
    });
    finder.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target.closest('a') : null;
      if (!target || !finder.contains(target)) return;
      const entry = target.closest('[data-rr-country]');
      if (entry || target.matches('[data-rr-all-countries]')) {
        dispatch('rr:collection-explore', {
          country: entry ? entry.dataset.countryHandle : 'all',
          destination: target.getAttribute('href'),
          mode: full ? 'directory' : 'homepage',
        });
      }
    });
    finder.dataset.enhanced = 'true';
    controls.hidden = false;
    update();
  };

  const initializeWithin = (root) => {
    if (root instanceof Element && root.matches('[data-rr-country-finder]')) initialize(root);
    root.querySelectorAll('[data-rr-country-finder]').forEach(initialize);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeWithin(document));
  else initializeWithin(document);
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
